import React from "react";
import CommonHeading from "../common/CommonHeading";
import { services } from "../data/Data";

import { PiBathtub } from "react-icons/pi";
import { FaCheck } from "react-icons/fa";
import { TbSofa } from "react-icons/tb";
import { CiLock } from "react-icons/ci";
import { MdOutlineBedroomChild } from "react-icons/md";
import { PiTelevisionSimpleLight } from "react-icons/pi";
import { CiForkAndKnife } from "react-icons/ci";
import { CiCircleInfo } from "react-icons/ci";
import { CiWifiOn } from "react-icons/ci";
import { CiParking1 } from "react-icons/ci";
import { LiaHandsHelpingSolid } from "react-icons/lia";
import { SiGoogleclassroom } from "react-icons/si";
import { PiWashingMachineThin } from "react-icons/pi";
import { MdOutlineBusinessCenter } from "react-icons/md";
import { NavLink } from "react-router-dom";
export default function Services() {
  return (
    <>
      <div className="container py-5 px-0">
        <div className="">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <CommonHeading
              heading="Our Services"
              title="Services"
              subtitle="Explore Our"
            />
          </div>
          <div className="row g-4">
            {services.map((item, index) => (
              <div
                key={index}
                className="col-lg-6 col-md-6 wow fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="service-item rounded">
                  <div className="service-icon bg-transparent border rounded p-1">
                    <div className="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                      {item.icon}
                    </div>
                  </div>
                  <h5 className="mb-3">{item.name}</h5>
                  <p className="text-body mb-0">{item.discription}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="col-12 container-sm amenities py-5">
            <div className="text-center wow fadeInUp py-5">
              <h6 className="section-title text-center text-warning text-uppercase">
                Facilities
              </h6>
              <h1 className="">
                Facilities of
                <span className="text-warning text-uppercase"> BGM HOTEL</span>
              </h1>
            </div>
            <div className="card p-1 facilities">
              <div className="card p-1">
                <div className="card p-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <PiBathtub /> &nbsp; Bathroom
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Toilet paper
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Bidet
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Towels/sheets (extra fee)
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Private bathroom
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Toilet
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Free toiletries
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Shower
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <TbSofa /> &nbsp; Living Area
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Dining area
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Sofa
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Fireplace
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Seating Area
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Desk
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <MdOutlineBedroomChild /> &nbsp; Bedroom
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Linen
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Wardrobe or closet
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <CiLock /> &nbsp; Safety & security
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Fire extinguishers
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> CCTV outside property
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> CCTV in common areas
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Smoke alarms
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Security alarm
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Key access
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> 24-hour security
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <PiTelevisionSimpleLight /> &nbsp; Media & Technology
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> TV
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <CiForkAndKnife /> &nbsp; Food & Drink
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Special diet menus (on
                        request)
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <CiCircleInfo /> &nbsp; General
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Designated smoking area
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Air conditioning
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Non-smoking throughout
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Allergy-free room
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Heating
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Carpeted
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Lift
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Fan
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Non-smoking rooms
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <CiWifiOn /> &nbsp; Internet
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> WiFi is available in all
                        areas and is free of charge.
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <CiParking1 /> &nbsp; Parking
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Free private parking is
                        possible on site (reservation is not needed).
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <LiaHandsHelpingSolid /> &nbsp; Reception services
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Invoice provided
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Private check-in/check-out
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Luggage storage
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> 24-hour front desk
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <SiGoogleclassroom /> &nbsp; Room Amenities
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Socket near the bed
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <PiWashingMachineThin /> &nbsp; Cleaning services
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Daily housekeeping
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <h6 className="">
                        <MdOutlineBusinessCenter /> &nbsp; Business facilities
                      </h6>
                      <p className="">
                        <FaCheck className="icon" /> Fax/photocopying
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Business centre
                      </p>
                      <p className="">
                        <FaCheck className="icon" /> Meeting/banquet facilities
                      </p>
                    </div>
                  </div>
                  <h5 className="text-info text-center">
                    For more inquiry
                    <NavLink to={"contact"} className="text-info">
                      &nbsp;Click here
                    </NavLink>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
